<ng-container *ngIf="dhwHygiene$ | async as hygiene">
  <div class="section-wrapper">
    <h3 class="section-heading">
      {{ '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_PROGRAM_SECTION' | translate }}
    </h3>
    <div class="hygiene-wrapper">
      <div [ngClass]="hygiene.properties?.enabled?.value ? 'hygiene-row-on' : 'hygiene-row-off'">
        <span>{{
          '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_PROGRAM_TITLE_ENABLED' | translate
        }}</span>
        <span>
          <!-- 1. Enable Hygiene Toggle -->
          <mat-slide-toggle
            #enableSwitch
            data-at-dhw-hygiene-enabled-toggle
            gtm="onToggle"
            gtmAction="Switch hygiene program ENABLED"
            gtmCategory="Manage features"
            [checked]="hygiene.properties?.enabled?.value"
            (click)="onHygieneEnabledToggle(enableSwitch, !hygiene.properties?.enabled?.value)"
            [class.disabled]="
              hygiene.properties?.enabled?.value
                ? !(hygiene | executable: 'disable')
                : !(hygiene | executable: 'enable')
            "
            [disabled]="
              hygiene.properties?.enabled?.value
                ? !(hygiene | executable: 'disable')
                : !(hygiene | executable: 'enable')
            "
          >
          </mat-slide-toggle
        ></span>
      </div>

      <div class="hygiene-row-on" *ngIf="hygiene.properties?.enabled?.value">
        <span>{{
          '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_PROGRAM_TITLE_STATUS' | translate
        }}</span>
        <span>
          <!-- 2. Activate Hygiene Toggle -->
          <span class="row-value">
            <span>{{ (hygiene.properties?.active?.value ? 'on' : 'off') | translateState }}</span>
            <mat-slide-toggle
              #activateSwitch
              data-at-dhw-hygiene-status-toggle
              gtm="onToggle"
              gtmAction="Switch hygiene program STATUS"
              gtmCategory="Manage features"
              (click)="onHygieneActivateToggle(activateSwitch)"
              [checked]="hygiene.properties?.active?.value"
              [class.disabled]="
                hygiene.properties?.active?.value || !(hygiene | executable: 'activate')
              "
              [disabled]="hygiene.properties?.active?.value || !(hygiene | executable: 'activate')"
            >
            </mat-slide-toggle>
          </span>
        </span>
      </div>

      <div
        class="hygiene-row-on hygiene-row-on-wide-content"
        *ngIf="dhwHygieneTrigger$ | async | ready as dhwHygieneTrigger"
      >
        <span>{{
          '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_PROGRAM_TITLE_ACTIVATION' | translate
        }}</span>
        <span class="hygiene-settings">
          <!-- 1. Hygiene reapatability time dropdown  -->

          <!-- Important technical detail
                "Everyday" is represented as an array of [7 entries]
                where "Every Week" is represented as an array of [1 entry] 
                this has an implication that we must use additional methods to calculate display value -->
          <ng-container>
            <mat-form-field mat-select-height-small>
              <mat-select
                data-at-dhw-hygiene-activation-repeatability-dropdown
                (selectionChange)="
                  onHygieneActivationRepeatabilityChange($event, dhwHygieneTrigger)
                "
                [value]="hygieneRepeatabilityValue.value"
                [placeholder]="hygieneRepeatabilityValue.viewValue"
                [class.disabled]="!hygiene.properties?.enabled?.value"
                [disabled]="!hygiene.properties?.enabled?.value"
              >
                <mat-option
                  *ngFor="let option of hygieneActivationScheduleOptions"
                  [value]="option.value"
                >
                  {{ option.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
          <span>
            {{
              '+INSTALLATIONS.INSTALLATION.WARM_WATER.HYGIENE_PROGRAM_TITLE_ACTIVATION_AT'
                | translate
            }}
          </span>
          <!-- 2. Hygiene activation time dropdown  -->
          <ng-container>
            <mat-form-field mat-select-height-small>
              <mat-select
                data-at-dhw-hygiene-activation-time-dropdown
                (selectionChange)="onHygieneActivationTimeChange($event, dhwHygieneTrigger)"
                [value]="hygieneActivationTimeValue"
                [placeholder]="hygieneActivationTimeValue"
                [class.disabled]="!hygiene.properties?.enabled?.value"
                [disabled]="!hygiene.properties?.enabled?.value"
              >
                <mat-option *ngFor="let option of hygieneActivationTimeOptions" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </span>
      </div>
    </div>
  </div>
</ng-container>
